import { MessageCircle } from "lucide-react";
import { CONTACT } from "@/data/site";

export default function WhatsAppFab() {
    return (
        <a
            href={CONTACT.whatsapp}
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Chat on WhatsApp"
            className="fixed bottom-5 right-5 z-50 flex h-14 w-14 items-center justify-center rounded-full bg-[#25D366] text-white shadow-[0_12px_32px_-8px_rgba(37,211,102,0.6)] transition-transform duration-300 hover:scale-105"
            data-testid="whatsapp-fab"
        >
            <MessageCircle size={26} />
        </a>
    );
}
